import React, { useState,useEffect } from "react";
import "./Microsoft365Backup.css";
import Box from "@mui/material/Box";
import {
  Row,
  Col
} from "react-bootstrap";
import Axios from "axios";
import {API_ROUTE, Routes } from "./Constants";
import Microsoft365Pricing from './Microsoft365Pricing';
export const Microsoft365Backup = (props) => {

    const [terms, setTerms] = useState([]);
    const termsData = async () => {
        //const tokenString = await setAuthContext("", new Date());
        let config = {
            headers: {
                Authorisation: "Bearer NOT REQUIRED`",
            },
        };
        const response = await Axios.get(API_ROUTE + Routes.GET_ALL_TERMS, config);
        if (response && response.data) {
            const responseData = JSON.parse(JSON.stringify(response.data));
            responseData.sort((a, b) => a.sortOrder - b.sortOrder);
            setTerms(responseData);
        }
    };
    useEffect(() => {
        termsData();
    }, []); 
  return (
    <>
      <Row className="p-3 pe-4" style={{ borderRadius: "8px",height:'72rem' }}>
        <Col sm={12}>
          <Microsoft365Pricing
            isBlurred={props.isBlurred}
          />
        </Col>
      </Row>
      <Box className="p-3 pt-0 scaleup">
              { terms.length !== 0 && (
                  <div
                      className="m-3 p-3"
                      style={{ borderRadius: "8px", border: "1px solid #5091ce", textAlign: 'left' }}
                  >
                      <ol className="ps-3 m-0">
                          {terms.map((term, index) => (
                              <li key={index} className=" mb-2">
                                  {term.termDescription}
                              </li>
                          ))}
                      </ol>
                  </div>
              )}
      </Box>
      <Box className="p-3 pt-0 scaleup">
              <div
          className="bg-white p-3"
          style={{
            borderRadius: "8px",
            border: "1px solid #5091ce",
            textAlign: "left",
          }}
        >
          <div className="col-12 justify-content-start d-flex">
            <span className="text-muted me-1">
              * Click{" "}
              <a
                href="#"
                style={{ fontSize: "13px" }}
                className="text-primary text-decoration-underline me-1"
                onClick={props.handleRequestShow}
              >
                HERE
              </a>{" "}
              to claim a 14-day trial of CloudCover 365.
            </span>
          </div>
          <div className="col-12 justify-content-start d-flex">
            <span className="text-muted">
              * This pricing is intended as a guide, and we are happy to discuss
              your requirements in more detail.
            </span>
          </div>
          <div className="col-12 justify-content-start d-flex">
            <span className="text-muted me-1">
              * For full service terms and conditions click{" "}
              <a
                href="https://www.virtualdcs.co.uk/downloads"
                style={{ fontSize: "13px" }}
                className="text-primary text-decoration-underline"
              >
                {" "}
                HERE.
              </a>
            </span>
          </div>
          <div className="col-12 justify-content-start d-flex">
            <span className="text-muted">
              * Please note: Shared Mailboxes are not charged as part of the
              service.
            </span>
          </div>
        </div>
      </Box>
      
    </>
  );
};

export default Microsoft365Backup;
